import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/fructidor/fructidor-ui/releases/20250530130804/app/[lng]/(home)/transport_logistics/[id]/TransportandLogisticsPage.tsx");
